import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { tuple } from '../_utils/type';
import Pagination from '../pagination';
import ListItem from './list-item';
export var OmitProps = tuple('handleFilter', 'handleClear', 'checkedKeys');
function parsePagination(pagination) {
  if (!pagination) {
    return null;
  }
  var defaultPagination = {
    pageSize: 10
  };
  if (_typeof(pagination) === 'object') {
    return _extends(_extends({}, defaultPagination), pagination);
  }
  return defaultPagination;
}
var ListBody = function ListBody(props) {
  var _context;
  var prefixCls = props.prefixCls,
    itemSelect = props.onItemSelect,
    itemRemove = props.onItemRemove,
    pagination = props.pagination,
    filteredRenderItems = props.filteredRenderItems,
    selectedKeys = props.selectedKeys,
    globalDisabled = props.disabled,
    showRemove = props.showRemove;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var mergedPagination = useMemo(function () {
    return parsePagination(pagination);
  }, [pagination]);
  var onItemSelect = function onItemSelect(item) {
    var checked = selectedKeys.indexOf(item.key) >= 0;
    itemSelect(item.key, !checked);
  };
  var onItemRemove = function onItemRemove(item) {
    itemRemove && itemRemove([item.key]);
  };
  var onPageChange = function onPageChange(current) {
    setCurrent(current);
  };
  var getItems = function getItems() {
    var displayItems = filteredRenderItems;
    if (mergedPagination) {
      displayItems = _sliceInstanceProperty(filteredRenderItems).call(filteredRenderItems, (current - 1) * mergedPagination.pageSize, current * mergedPagination.pageSize);
    }
    return displayItems;
  };
  useEffect(function () {
    var total = filteredRenderItems.length;
    if (mergedPagination && (current - 1) * mergedPagination.pageSize >= total) {
      var pageSize = mergedPagination.pageSize;
      var pageNo = total % pageSize === 0 ? total / pageSize : Math.floor(total / pageSize) + 1;
      setCurrent(pageNo);
    }
  }, [mergedPagination, filteredRenderItems]);
  var paginationNode = null;
  if (mergedPagination) {
    paginationNode = /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-pagination")
    }, /*#__PURE__*/React.createElement(Pagination, {
      pageType: "simple",
      disabled: globalDisabled,
      current: current,
      total: filteredRenderItems.length,
      pageSize: mergedPagination.pageSize,
      showQuickJumper: false,
      onChange: onPageChange
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: classNames("".concat(prefixCls, "-content"))
  }, _mapInstanceProperty(_context = getItems()).call(_context, function (_ref) {
    var renderedEl = _ref.renderedEl,
      renderedText = _ref.renderedText,
      item = _ref.item;
    var disabled = item.disabled;
    var checked = selectedKeys.indexOf(item.key) >= 0;
    return /*#__PURE__*/React.createElement(ListItem, {
      disabled: globalDisabled || disabled,
      key: item.key,
      item: item,
      renderedText: renderedText,
      renderedEl: renderedEl,
      checked: checked,
      prefixCls: prefixCls,
      onClick: onItemSelect,
      showRemove: showRemove,
      onRemove: onItemRemove
    });
  })), paginationNode);
};
export default ListBody;